import { Directive, HostListener } from '@angular/core';

/**
 * Directive to stop propagation on tap (touchstart).
 * We make use of this to not trigger tooltips when we tap on mobile.
 * On mobile we want just the actual action to be triggered, _not_ the tooltip!
 */
@Directive({
  selector: '[ccTouchStartStopPropagation]',
  standalone: true
})
export class TouchStartStopPropagationDirective {
  @HostListener('touchstart', ['$event'])
  public onTouchStart(event: TouchEvent): void {
    event.stopPropagation();
  }
}
